module.exports = __webpack_public_path__ + "img/zoom_in-24px.0911ec42.svg";